import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormCustomFieldInput', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/custom_fields/input/input.html'),
        controller: 'InputCustomFieldFormController',
        controllerAs: 'InputCustomFieldFormCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            field: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/custom_fields/input/input.component.ts